import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

export function InvalidState() {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="state-icon danger" aria-hidden="true">
        ×
      </div>
      <h1>{t('invalid.title')}</h1>
      <p>{t('invalid.body')}</p>
    </Card>
  );
}
